import React from 'react';
import styled from 'styled-components';

const ReferenceLineLabelContainer = styled.text`
  display: flex;
  flex-direction: row;
  align-items: center;
  fill: #e44b27;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-weight: 600;
  font-size: 12px;

  .ht {
    font-size: 12px;
    fill: black;
    opacity: 0.3;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }
`;

const ReferenceLineLabel = ({ viewBox, value }) => (
  <ReferenceLineLabelContainer>
    <tspan
      x={viewBox.x + viewBox.width + 20}
      y={viewBox.y}
      dy={2}
      textAnchor="middle"
    >
      {value}
    </tspan>
  </ReferenceLineLabelContainer>
);

export default ReferenceLineLabel;
